module.exports = __webpack_public_path__ + "img/DT.a8b653e8.png";